export default class Container {
  constructor(options) {
    this.element = options.element;
    this.data = options.data;
    this.index = options.index;
    this.onDelete = options.onDelete;
    this.updateState = options.updateState;
    if (options.editable) {
      if (options.deleteButton) this.deleteButton = options.deleteButton;
      this.configureEditableOptions();
    }
  }

  configureEditableOptions() {
    let deleteButton = (this.deleteButton) ? this.deleteButton
                                           : this.element.getElementsByClassName("delete")[0];

    this.element.onmouseover = () => {
      deleteButton.style.display = 'block';
    }

    this.element.onmouseout = () => {
      deleteButton.style.display = 'none';
    }

    deleteButton.onclick = (event) => {this.onDelete(event,
                                                     this.data,
                                                     this.index,
                                                     this.updateState)};
  }

  getElement() {
    return this.element;
  }

  getField(className) {
    return this.element.getElementsByClassName(className)[0];
  }
}



// WEBPACK FOOTER //
// ./src/editors/editable/Container.js